/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const PLAY_CIRCLE_VIEWBOX = 24;

const PLAY_CIRCLE_PATH =
  'M16 10.27L11 7.38C10.6961 7.20455 10.3514 7.11214 10.0005 7.11205C9.64962 7.11196 9.30487 7.20419 9.00089 7.37949C8.69691 7.55478 8.44441 7.80697 8.26872 8.11072C8.09304 8.41447 8.00036 8.7591 8 9.11V14.89C8.00036 15.2407 8.09295 15.5852 8.26847 15.8888C8.44398 16.1925 8.69627 16.4446 9 16.62C9.30404 16.7955 9.64893 16.8879 10 16.8879C10.3511 16.8879 10.696 16.7955 11 16.62L16 13.73C16.3031 13.5542 16.5547 13.3018 16.7295 12.9982C16.9044 12.6946 16.9965 12.3504 16.9965 12C16.9965 11.6496 16.9044 11.3054 16.7295 11.0018C16.5547 10.6982 16.3031 10.4458 16 10.27ZM15 12L10 14.89V9.11L15 12ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z';

/** Default fill from Figma asset. */
export const PLAY_CIRCLE_ICON_DEFAULT_FILL = '#61677F';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Play circle (24×24 outline). Color via `fill` or CSS `color` + `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const PlayCircleIcon = ({
  size = 24,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${PLAY_CIRCLE_VIEWBOX} ${PLAY_CIRCLE_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={PLAY_CIRCLE_PATH} fill={fill} />
  </svg>
);

PlayCircleIcon.propTypes = iconPropTypes;

export { PlayCircleIcon };
export default PlayCircleIcon;
